import { render, staticRenderFns } from "./RegisterTwo.vue?vue&type=template&id=6aac30d3&scoped=true&"
import script from "./RegisterTwo.vue?vue&type=script&lang=js&"
export * from "./RegisterTwo.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTwo.vue?vue&type=style&index=0&id=6aac30d3&prod&lang=less&scoped=true&"
import style1 from "./RegisterTwo.vue?vue&type=style&index=1&id=6aac30d3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aac30d3",
  null
  
)

export default component.exports